import { render, staticRenderFns } from "./InputCompuesto.vue?vue&type=template&id=e5de1552"
import script from "./InputCompuesto.vue?vue&type=script&lang=js"
export * from "./InputCompuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports